/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-05 11:29:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { connect } from 'react-redux';
import { Icon } from '@shopify/polaris';
import { ChevronRightMinor, EmbedMinor } from '@shopify/polaris-icons';
import Classnames from 'classnames';
import { withI18n } from '@shopify/react-i18n';
import { templateBuilder, formatTemplate } from 'boost-template-engine';

import { ReactComponent as IconFolder } from 'src/assets/images/shopify-integration-settings/folder.svg';
import { MAP_MENU_DEVELOPER_FOLDER } from 'src/constants/theme-settings';
import * as ShopifyIntegrationSettingsAction from 'src/stores/actions/shopify-integration/shopify-integration-settings-actions';
import Emitter, { EVENT_KEY } from 'src/libs/eventEmitter';

type Props = {};

type ComposedProps = Props & WithI18nProps;

type State = {};

class MenuDeveloperFolder extends Component<ComposedProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.isOpen && nextProps.searching) {
      this.handleToggleFolderDelay(true);
    }
  }

  handleToggleFolderDelay = _.debounce(value => {
    this.setState({
      isOpen: value
    });
  }, 750);

  toggleCollapse = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  handleSelectSection = template => {
    const { updateMultiFieldsReducer, templatesEditing, widgetSettings } = this.props;
    Emitter.emit(EVENT_KEY.SAVE_EDITOR_STATE);

    const customizeTemplate = !_.isEmpty(template.customizeTemplate)
      ? template.customizeTemplate
      : formatTemplate(templateBuilder(template.widgetTemplate, widgetSettings, {}, true));

    const payload = {
      customizeTemplate,
      codeEditTemplate: template
    };

    if (_.isEmpty(templatesEditing[template?.widgetId])) {
      payload.templatesEditing = {
        ...templatesEditing,
        [template?.widgetId]: {
          customizeTemplate,
          originalTemplate: customizeTemplate,
          isEditing: false
        }
      };
    }

    updateMultiFieldsReducer(payload);
  };

  render() {
    const { i18n, name, widgets = [], codeEditTemplate, templatesEditing } = this.props;
    const { isOpen } = this.state;
    const menuClass = Classnames('menu-developer-folder', {
      'menu-developer-folder--opened': isOpen
    });

    const title = i18n.translate(MAP_MENU_DEVELOPER_FOLDER[name]);
    return (
      <div className={menuClass}>
        <div className="menu-developer-folder__title" onClick={this.toggleCollapse}>
          <div className="menu-developer-folder__title__name">
            <IconFolder />
            <p>{title}</p>
          </div>

          <Icon source={ChevronRightMinor} />
        </div>
        <Collapse isOpened={isOpen}>
          {!!widgets.length &&
            widgets.map(item => {
              return (
                <div
                  className={Classnames('menu-developer-file', {
                    'menu-developer-file--active': item?.widgetId === codeEditTemplate?.widgetId,
                    'menu-developer-file--editing': templatesEditing[item?.widgetId]?.isEditing
                  })}
                  key={item.widgetId}
                  onClick={() => this.handleSelectSection(item)}>
                  <Icon source={EmbedMinor} />
                  <p>{item?.widgetName}</p>
                </div>
              );
            })}
        </Collapse>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateFieldReducer: (fieldName, data) =>
    dispatch(ShopifyIntegrationSettingsAction.handleUpdateField(fieldName, data)),
  updateMultiFieldsReducer: data =>
    dispatch(ShopifyIntegrationSettingsAction.handleUpdateMultiFields(data))
});

const mapStateToProps = (state, props) => {
  const widgetSettings = _.get(state, 'themeIntegration.widgetSettings', {});

  return {
    widgetSettings,
    templatesEditing: _.get(state, 'shopifyIntegrationSettings.templatesEditing', {})
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(MenuDeveloperFolder));
